import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, EventEmitter, Inject, Input } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatSnackBar } from "@angular/material";
import { AuthenticationService, DevolucionService, FulfillmentService } from "src/app/_services";
import { environment } from "src/environments/environment";
import { first } from 'rxjs/operators';

@Component({
    selector: 'form-data-shipment',
    templateUrl: './dialog-form-data-shipment.component.html',
  })
export class FormDataShipmentComponent {

    formGuide: FormGroup;

    name: FormControl;

    email: FormControl;

    phone: FormControl;

    street: FormControl;

    noExt: FormControl;

    noInt: FormControl;

    colony: FormControl;

    city: FormControl;

    state: FormControl;

    zipCode: FormControl;

    channel: FormControl;

    orderNumber: FormControl;

    shipmentType: FormControl;

    carrierName: FormControl;

    trackingNumber: FormControl;

    mensaje_success: Boolean = false;

    error: Boolean = false;

    spinner: Boolean = false;

    hasGuide: Boolean = false;

    devolutionNumber: FormControl;

    fileToUpload: File = null;

    formFile: FormControl;

    fileName: string;

    items: any[] = [];

    toppingList: string[] = [];

    checkInvRec: FormControl;

    peso: FormControl;

    largo: FormControl;

    ancho: FormControl;

    alto: FormControl;

    tipoPaqueteList = [];

    packageType: FormControl;

    @Input()
    onSuccess = new EventEmitter();

    orderCode: string = null;

    productos: Array<{
      id: any;
      title: string;
      seller_sku: string;
      cantidad: number;
      weight: number;
      length: number;
      width: number;
      height: number;
        list_price: number;
    }> = [];

    constructor(
      private formBuilder: FormBuilder,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private _httpClient: HttpClient,
      private snackBar: MatSnackBar,
      private fulfillmentService: FulfillmentService,
      private authenticationService: AuthenticationService,
      private devolucionService: DevolucionService,
    ) {
      
      this.hasGuide = this.data.hasGuide;

      this.items = this.data.items;

      const dataShipment = this.data.dataShipment;

      const devolutionList = this.data.devolutionList;

      const checkInvRec = this.data.checkInvRec;

      const shipmentType = !this.hasGuide ? 'economico' : (dataShipment ? dataShipment.tipo_envio : '');

      const carrierName = !this.hasGuide ? 'Estafeta' : (dataShipment ? dataShipment.carrier_name : '');

      this.name = new FormControl(dataShipment ? dataShipment.receiver_name : '', [Validators.required]);

      this.email = new FormControl(dataShipment ? dataShipment.email : '', [Validators.required, Validators.email]);

      this.phone = new FormControl(dataShipment ? dataShipment.phone : '', [Validators.required]);

      this.street = new FormControl(dataShipment ? dataShipment.street : '', [Validators.required]);

      this.noExt = new FormControl(dataShipment ? dataShipment.external_number : '', [Validators.required]);

      this.noInt = new FormControl(dataShipment ? dataShipment.internal_number : '');

      this.colony = new FormControl(dataShipment ? dataShipment.colony : '', [Validators.required]);

      this.city = new FormControl(dataShipment ? dataShipment.ciudad : '', [Validators.required]);

      this.state = new FormControl(dataShipment ? dataShipment.estado : '', [Validators.required]);

      this.zipCode = new FormControl(dataShipment ? dataShipment.codigo_postal : '', [Validators.required]);

      this.channel = new FormControl(devolutionList ? devolutionList.channel : '', [Validators.required]);

      this.orderNumber = new FormControl(devolutionList ? devolutionList.order_number : '', [Validators.required]);

      this.shipmentType = new FormControl(shipmentType, [Validators.required]);

      this.carrierName = new FormControl(carrierName, [Validators.required]);

      this.devolutionNumber = new FormControl(devolutionList ? devolutionList.devolucion_multicanal_id : '', [Validators.required]);

      this.formFile = new FormControl('');

      this.trackingNumber = new FormControl(dataShipment ? dataShipment.tracking_number : '', [Validators.required]);

      this.checkInvRec = new FormControl(checkInvRec ? checkInvRec : false, [ ]);

      this.peso = new FormControl(dataShipment ? dataShipment.peso : '', [Validators.required]);

      this.largo = new FormControl(dataShipment ? dataShipment.largo : '', [Validators.required]);

      this.ancho = new FormControl(dataShipment ? dataShipment.ancho : '', [Validators.required]);

      this.alto = new FormControl(dataShipment ? dataShipment.alto : '', [Validators.required]);

      this.packageType = new FormControl(dataShipment ? dataShipment.package_type : '', [Validators.required]);

      this.formGuide = this.formBuilder.group({
        id: devolutionList ? devolutionList.id : null,
        name: !this.hasGuide ? this.name : null,
        email: !this.hasGuide ? this.email : null,
        phone: !this.hasGuide ? this.phone : null,
        street: !this.hasGuide ? this.street : null,
        noExt: !this.hasGuide ? this.noExt : null,
        noInt: !this.hasGuide ? this.noInt: null,
        colony: !this.hasGuide ? this.colony : null,
        city: !this.hasGuide ? this.city : null,
        state: !this.hasGuide ? this.state : null,
        zipCode: !this.hasGuide ? this.zipCode : null,
        channel: this.channel,
        orderNumber: this.orderNumber,
        shipmentType: this.shipmentType,
        carrierName: this.carrierName,
        devolutionNumber: this.devolutionNumber,
        trackingNumber: this.hasGuide ? this.trackingNumber : null,
        checkInvRec: this.checkInvRec,
      });

      this.updateToppingList();

      this.shipmentType.setValue(shipmentType);
      this.carrierName.setValue(carrierName);

      this._httpClient.get(`${environment.apiUrl}/rmsfe/boxes`).subscribe(
        (res: any) => {
          this.tipoPaqueteList = res;
        },
      );
    }

    registerReturn(){
      this.spinner = true;

      const validate = this.formGuide.valid;

      if(!validate){
        this.spinner = false;
        this.snackBar.open("Debe llenar todos los campos", "OK", {
          duration: 3500,
        });
        return;
      }

      if(this.items.length > 0) {
        this.items.forEach(item => {
          this.devolucionService.get_information_item_rmsfe(item.item_id).pipe(first()).subscribe(data => {
            const { id, seller_sku, title, weight, length, width, height, list_price } = data.body.objeto;
            this.productos.push({
              id: id,
              title: title,
              seller_sku: seller_sku,
              cantidad: item.quantity,
              weight: weight || 0,
              length: length || 0,
              width: width || 0,
              height: height || 0,
              list_price: list_price || 0.0
            })
          });
        });
      };

      setTimeout(() => {
        if (!this.hasGuide) {
          this.generarGuia();
          return;
        }
          
        this._httpClient.post<any>(`${environment.apiUrl}/rmsfe/create_no_register_order_devolution`, {
          ...this.formGuide.value,
          hasGuide: this.hasGuide,
          fileName: this.fileName,
          items: this.items,
        }).subscribe(
          (res) => {
            this.spinner = false;
            this.mensaje_success = true;
            this.error = false;
            this.onSuccess.emit();
          },
          (error) => {
            this.spinner = false;
            this.error = true;
            this.mensaje_success = false;
          }
        );
      }, 500);
    }

    handleFileInput(files: FileList) {
      this.fileToUpload = files.item(0); 
      let tipo_archivo = this.fileToUpload.name.match(/(.pdf)/);
      if (tipo_archivo != null){
  
        this.spinner = true;
        this.formFile.disable();
    
        this.fulfillmentService.getUploadURl(this.fileToUpload.type)
        .pipe(first())
        .subscribe(
          data => { 
            if(data.status == 200){
              this.subirAWS(data.body["data"], this.fileToUpload);
            }else{ 
            }
          },
          error => {
        });
      }else{
        this.snackBar.open("Debe seleccionar un archivo pdf", "OK", {                      
          duration: 3500,
        });
        this.formFile.setValue(null);
      } 
    }
  
    subirAWS(response, fileToUpload){ 
      this.fulfillmentService.subirArchivo(response.url, fileToUpload)
      .pipe(first())
      .subscribe(
        data => { 
          this.fileName = response.file_name;
          this.spinner = false;
          this.formFile.enable();
          this.snackBar.open("La guía se cargó correctamente", "OK", {                      
            duration: 3500,
          });
        },
        error => {
          this.spinner = false;
          this.formFile.enable();
          this.snackBar.open("Ocurrió un error al cargar la guía, intentelo de nuevo.", "OK", {                      
            duration: 3500,
          });
      });
  
    }

    updateToppingList(){
      let tipo_envio = this.shipmentType.value;
      switch (tipo_envio) {
        case 'CoD_next_day':
          this.toppingList = ['Mas económico'];
        break;
        case 'CoD_same_day':
          this.toppingList = ['Mas económico'];
        break;
        case 'mismo_dia':
          this.toppingList = ['Mas económico', '99m'];
        break;
        case 'dia_siguiente':
          this.toppingList = ['Mas económico', 'Estafeta', 'FedEx', 'Internacional', 'will_call', 'Amazon','DHL', 'MercadoLibre','99m','otro', 'tiui'];
        break;
        case 'economico':
          this.toppingList = ['Mas económico', 'AMPM','Estafeta', 'FedEx', 'Internacional', 'Paquetexpress', 'will_call', 'Amazon','DHL', 'MercadoLibre','99m','otro', 'tiui'];
        break;
      
        default:
        break;
      }
    }

    reload(){
      location.reload();
    }
    
    generateRandomCode() : string{
      return (Math.random() + 1).toString().substring(2);
    }

    async generarGuia(){
      const validate = this.formGuide.valid;

      if(!validate){
        this.snackBar.open("Debe llenar todos los campos", "OK", {
          duration: 3500,
        });
        return;
      }

      this.orderCode = this.generateRandomCode();

      const datos_envio = {
        items: this.productos,
        orden_id: this.orderCode,  
        paquete_info: {
          "tipo_paquete": this.packageType.value,
          "asegurado": false,
          "tipo_envio": this.shipmentType.value,
          "paqueteria": this.carrierName.value
        },  
        paquetes: [
          {
            "largo": this.largo.value,
            "ancho": this.ancho.value,
            "alto": this.alto.value,
            "peso": this.peso.value
          }
        ],
        origen:{
          "estado": this.state.value,
          "colonia": this.colony.value,
          "calle": this.street.value,
          "no_ext": this.noExt.value,
          "no_int": this.noInt.value,
          "telefono": this.phone.value,
          "codigo_postal": this.zipCode.value,
          "nombre_contacto": this.name.value,
          "email": this.email.value,
          "ciudad": this.city.value,
          "pais": "Mexico",
          "codigo_pais": "MX",
          "company": "Estafeta"
        },
        destino:{
          "estado": "Ciudad de Mexico",
          "colonia": "Naucalpan de Juarez",
          "calle": "Norte",
          "no_ext": "4, Industrial Alce Blanco",
          "no_int": null,
          "telefono": "5564034746",
          "codigo_postal": 53370,
          "nombre_contacto": "MARKETFUL",
          "email": "soporte.fulfillment@zubut.com",
          "ciudad": "Ciudad de Mexico",
          "pais": "Mexico",
          "codigo_pais": "MX",
          "company": "MARKETFUL"
        }
      };

      this.spinner = true;
      
      this.devolucionService.generar_guia_devoluciones_api(datos_envio)
        .pipe(first())
        .subscribe(
          async data => {
            if(data.result.status == 200){
              await this.consultar_status_guia(datos_envio.orden_id);
            }else{
              this.spinner = false;
              this.snackBar.open("Error al generar la guía, intente más tarde.", "OK", {
                duration: 5000,
              });
            }
          },
          error => {
            this.spinner = false;
          }
      );
    }

    async consultar_status_guia(order_id){
      this.devolucionService.consultar_sta_gui(order_id)
      .pipe(first())
      .subscribe(
        data => {
          if(data["body"]["result"].status == 200){
            var completado = false;
            var any_error = false;
            var datos_guia = null;
            var result_guia = null;
            var nom_paq = null;
            var guia_prepagada = false;
            var text_error = "Error al generar la guía, intente más tarde.";
            var origen = null;
            var destino = null;
            if(data["body"]["result"]["informe_pipeline"].completado){
              if(data["body"]["result"]["guia"]){
                if(data["body"]["result"]["guia"].guia_creada){

                  var isEmpty = Object.keys(data["body"]["result"]["guia"]["crear_guia"]).length === 0;
                  if(!isEmpty){
                    if(data["body"]["result"]["guia"]["crear_guia"].status == 200){
                      completado = true;
                      result_guia = data["body"]["result"]["guia"];
                      datos_guia = data["body"]["result"]["guia"]["crear_guia"];
                      nom_paq = data["body"]["result"]["guia"]["shipping_company"].shipping_company;
                      origen = data["body"]["result"]["guia"]["origen"];
                      destino = data["body"]["result"]["guia"]["destino"];
                      window.open(data["body"]["result"]["guia"]["crear_guia"].url);
                    }else{
                      any_error = true;
                    }
                  }
                }else{
                  var isEmpty = Object.keys(data["body"]["result"]["guia"]["response_status"]).length === 0;
                  if(!isEmpty){
                    if(data["body"]["result"]["guia"]["response_status"].status != 200){
                      text_error = data["body"]["result"]["guia"]["response_status"].message;
                      any_error = true;
                    }
                  }

                  var isEmpty2 = Object.keys(data["body"]["result"]["guia"]["crear_guia"]).length === 0;
                  if(!isEmpty2){
                    if(data["body"]["result"]["guia"]["crear_guia"].status != 200){
                      text_error = data["body"]["result"]["guia"]["crear_guia"].message;
                      any_error = true;
                    }
                  }
                }
              }
            }

            if(any_error){
              this.spinner = false;
              this.snackBar.open(text_error, "OK", {
                duration: 5000,
              });
            }else{
              if(completado){
                this.fileName = datos_guia.file_name;
                this.registerReturnWithGuide(datos_guia, result_guia, nom_paq, false, origen, destino);
              }else{
                setTimeout(() => {
                  this.consultar_status_guia(order_id);
                }, 1000);
              }
            }
          }else{
            setTimeout(() => {
							this.consultar_status_guia(order_id);
						}, 1000);
          }
        },
        error => {
          this.spinner = false;
          this.snackBar.open("Error al generar la guía, intente más tarde.", "OK", {
            duration: 5000,
          });
      });
    }

    registerReturnWithGuide(data, resultGuide, nomPaq, guia_prepagada = false, origen, destino){
      this.spinner = true;

      const validate = this.formGuide.valid;

      if(!validate){
        this.spinner = false;
        this.snackBar.open("Debe llenar todos los campos", "OK", {
          duration: 3500,
        });
        return;
      }
        
      this._httpClient.post<any>(`${environment.apiUrl}/rmsfe/create_no_register_order_devolution`, {
        ...this.formGuide.value,
        hasGuide: false,
        fileName: data.file_name,
        trackingNumber: data.tracking_number,
        items: this.items,
        guia_prepagada: guia_prepagada,
        alto: resultGuide["alto"],
        largo: resultGuide["largo"],
        ancho: resultGuide["ancho"],
        tipo_envio_final: resultGuide["tipo_envio_final"],
        shipping_platform: resultGuide["shipping_platform"],
        peso_reportado: resultGuide["peso_reportado"],
        num_paq: nomPaq,
        nombre_paquete: this.packageType.value,
        costo_guia: data.costo_guia,
        transactionId: data.label_transaction_id,
        label_shipping_platform: data.label_shipping_platform,
        origen: origen,
        destino: destino
      }).subscribe(
        (res) => {
          this.spinner = false;
          this.mensaje_success = true;
          this.error = false;
          this.onSuccess.emit();
        },
        (error) => {
          this.spinner = false;
          this.error = true;
          this.mensaje_success = false;
        }
      );
    }
}